<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ options[value] }}</dd>
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-tipo-pessoa",
  props: {
    label: String,
    value: String
  },
  data() {
    return {
      options: {
        ["fisica"]: "Física",
        ["juridica"]: "Jurídica"
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TipoPessoa.vue